<template>
  <div class="grade-bar-card">
     <div class="card-header">
      <div class="card-header-left">
        <p class="card-header-title">{{title}}</p>
        <p class="card-header-dataDesc">{{dataDesc}}</p>
        <i class="separator"></i>
        <p class="card-header-dataUpdateTime">更新于{{dataUpdateTime}}</p>
        <el-tooltip v-if="tooltip" effect="dark" placement="right" style="margin-left: 4px">
          <div slot="content" v-html="tooltip"></div>
          <i class="QS-icon-question-outline"></i>
        </el-tooltip>
      </div>
      <div class="card-header-right" v-if="btnText">
        <el-button v-if="btnText" type="text" size="mini" @click="handleBtnClick">{{btnText}}</el-button>
      </div>
    </div>
    <div class="card-body">
      <div class="card-body-inner">
        <div class="legends">
          <div class="legend" v-for="(item, index) in legendsData" :key="index">
            <i class="legend-point" :style="{background: colors[index] || colors[colors.length - 1]}"></i>
            <span class="legend-name">{{item}}</span>
          </div>
        </div>
        <div class="bar" v-for="(item, index) in data" :key="index">
          <div class="bar-name">{{item.name}}</div>
          <div class="sub-bars">
            <div class="sub-bar" v-for="(item, index) in item.data" :key="index">
              <div class="sub-bar-ratio" :style="{width: `${(item.ratio * 100).toFixed(2)}%`, background: colors[index] || colors[colors.length - 1]}"></div>
              <div class="sub-bar-data">
                <div class="sub-bar-data-item" v-for="(item, index) in item.data" :key="index">
                  {{item.name}} <span :class="{link: !!item.clickCallback}" @click="handleDataValueClick(item.clickCallback)">{{item.type === 'ratio'? ((item.value * 100).toFixed(2) + '%') : convertNumber(item.value, 0)}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { convertNumber } from '@/utils/'

const colors = ['#507AFC', '#0FC570', '#FAC858', '#D8D8D8']

export default {
  props: {
    // 标题
    title: {
      type: String,
      default: '',
    },
    // 数据描述
    dataDesc: {
      type: String,
      default: '',
    },
    // 数据更新时间
    dataUpdateTime: {
      type: String,
      default: '',
    },
    // 按钮文本
    btnText: {
      type: String,
      default: '',
    },
    colors: {
      default: () => colors,
    },
    // 图例
    legendsData: {
      default: () => ([]),
    },
    data: {
      default: () => ([]),
    },
    // 提示
    tooltip: {
      type: String,
      default: '',
    },
  },
  methods: {
    convertNumber,
    handleBtnClick() {
      this.$emit('btnClick')
    },
    handleDataValueClick(callback) {
      typeof callback === 'function' && callback()
    },
  },
}
</script>

<style lang="scss" scoped>
.grade-bar-card {
  border-radius: 2px;
  overflow: hidden;
  .card-header {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 38px;
    padding: 8px 12px;
    background: #F8F8FA;
    &::before {
      position: absolute;
      top: 50%;
      left: 0;
      margin-top: -9px;
      content: '';
      width: 3px;
      height: 18px;
      background: #0256FF;
      border-radius: 10px;
    }
    .card-header-left {
      display: flex;
      align-items: center;
      .card-header-title {
        font-size: 14px;
        font-weight: 600;
        line-height: 22px;
        color: #3D3D3D;
      }
      .card-header-dataDesc {
        margin-left: 10px;
        font-size: 12px;
        font-weight: normal;
        line-height: 22px;
        color: #767676;
      }
      .separator {
        width: 1px;
        height: 10px;
        margin: 0 6px;
        flex: none;
        background: #767676;
      }
      .card-header-dataUpdateTime {
        font-size: 12px;
        font-weight: normal;
        line-height: 22px;
        color: #767676;
      }
    }
    .card-header-right {

    }
  }
  .card-body {
    display: flex;
    width: 100%;
    min-height: 182px;
    padding: 27px 16px 27px 16px;
    border-left: 1px solid #ECEEF4;
    border-right: 1px solid #ECEEF4;
    border-bottom: 1px solid #ECEEF4;
    .card-body-inner {
       width: 100%;
       overflow: hidden;
    }
  }
}

.legends {
  display: flex;
  align-items: center;
  margin-left: 40px;
}
.legend {
  display: flex;
  align-items: center;
  margin-right: 12px;
}
.legend-point {
  display: flex;
  width: 6px;
  height: 6px;
  margin-right: 4px;
  border-radius: 2px;
}
.legend-name {
  font-size: 12px;
  line-height: 18px;
  color: rgba(0, 0, 0, 0.3);
}
.bar {
  display: flex;
  align-items: center;
}
.bar-name {
  flex: none;
  margin-right: 4px;
  font-size: 12px;
  line-height: 18px;
  color: rgba(0, 0, 0, 0.3);
}
.sub-bars {
  flex: 1;
  padding: 5px 0;
}
.sub-bar {
  display: flex;
  align-items: center;
}
.sub-bar-ratio {
  flex: 0 1 auto;
  min-width: 3px;
  height: 10px;
  border-radius: 0px 4px 4px 0px;
}
.sub-bar-data {
  flex: none;
  display: flex;
  align-items: center;
  margin-left: 4px;
}
.sub-bar-data-item {
  flex: none;
  margin-right: 4px;
  font-size: 12px;
  line-height: 14px;
  color: rgba(0, 0, 0, 0.5);
}
.link {
  color: #276BEC;
  cursor: pointer;
}
</style>
